/**
 * EmptyState Component
 *
 * Friendly empty state with icon, title, description, and optional action.
 *
 * IMPORTANT: Must use the Press.Zone design system classnames
 * so shared styles apply consistently across admin routes.
 *
 * @package MultilingualPressZone
 */

import { el } from '../utils/dom.js';

/**
 * Render a friendly empty state.
 *
 * @param {string} icon - Large emoji
 * @param {string} title - Empty state title
 * @param {string} description - Helpful description
 * @param {HTMLElement} action - Optional action button
 * @param {string} variant - Optional variant ('default' | 'welcome')
 */
export function EmptyState(icon, title, description, action = null, variant = 'default') {
    const className = variant === 'welcome'
        ? 'presszone-multilingual-empty-state presszone-multilingual-empty-state--welcome'
        : 'presszone-multilingual-empty-state';

    return el('div', { class: className },
        el('div', { class: 'presszone-multilingual-empty-state__icon' }, icon),
        el('h3', {}, title),
        el('p', {}, description),
        action ? el('div', { class: 'presszone-multilingual-empty-state__action' }, action) : null
    );
}

export default EmptyState;
